import createReducer from 'redux/createReducer';
import { TROLLEY_PRICING_REQUEST_SUCCESS } from 'redux/modules/pricing/actions/types';
import trolleyPricingReceived from './trolley-pricing';

const actionTypeReducerMap = new Map([[TROLLEY_PRICING_REQUEST_SUCCESS, trolleyPricingReceived]]);

export default createReducer({}, actionTypeReducerMap);
